import { render } from "./digitizings.vue?vue&type=template&id=194d5dae&scoped=true"
import script from "./digitizings.vue?vue&type=script&lang=js"
export * from "./digitizings.vue?vue&type=script&lang=js"

import "./digitizings.vue?vue&type=style&index=0&id=194d5dae&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194d5dae"]])

export default __exports__